document.addEventListener('DOMContentLoaded', function() {
    var productHandle = 'custom-pompom-beanie';

    if (productHandle === 'custom-pompom-beanie') {
        var quantityInput = document.querySelector('.form-field-input.form-field-number.form-field-filled');
        var addToCartButton = document.querySelector('.product-form--atc-button');
        var priceDisplayMain = document.querySelector('.product--price .price--main');
        var priceDisplayCompareAt = document.querySelector('.product--price .price--compare-at');
        var minQuantity = 10;

        var priceTiers = [
            { minQty: 10, price: 52.00 },
            { minQty: 20, price: 37.00 },
            { minQty: 50, price: 27.00 },
            { minQty: 100, price: 22.00 },
            { minQty: 150, price: 17.00 },
            { minQty: 200, price: 14.00 }
        ];

        if (quantityInput && addToCartButton && priceDisplayMain) {
            quantityInput.value = minQuantity; // Set initial value to 10

            function updatePrice() {
                var quantity = parseInt(quantityInput.value);
                if (isNaN(quantity) || quantity < minQuantity) {
                    quantity = minQuantity;
                }
                var price = priceTiers[0].price;

                for (var i = priceTiers.length - 1; i >= 0; i--) {
                    if (quantity >= priceTiers[i].minQty) {
                        price = priceTiers[i].price;
                        break;
                    }
                }

                priceDisplayMain.innerText = `$${price.toFixed(2)} NZD / each`;

                if (priceDisplayCompareAt) {
                    priceDisplayCompareAt.innerText = '';
                }

                // Trigger Orichi app's recalculation logic if necessary
                // Ensure Orichi app is aware of the updated quantity
                if (typeof OrichiApp !== 'undefined' && OrichiApp.recalculate) {
                    OrichiApp.recalculate();
                }
            }

            quantityInput.addEventListener('blur', function() {
                if (parseInt(quantityInput.value) < minQuantity || isNaN(parseInt(quantityInput.value))) {
                    quantityInput.value = minQuantity;
                }
                updatePrice();
            });

            quantityInput.addEventListener('input', function() {
                updatePrice();
            });

            addToCartButton.addEventListener('click', function(event) {
                if (parseInt(quantityInput.value) < minQuantity) {
                    event.preventDefault();
                    quantityInput.value = minQuantity;
                    alert('The minimum order quantity for this product is ' + minQuantity);
                } else {
                    updatePrice();
                }
            });

            updatePrice(); // Update price on page load
        } else {
            console.error('Quantity Input, Add to Cart Button, or Price Display not found');
        }
    }
});
